import { Banner } from '../../bannerStore'
import Component from './banner.vue'
import store from '@/store'

const banner: Banner = {
  id: 'july_2026_office_automation_banner',
  created: new Date('2026-06-30T00:00:00-06:00'),
  expiry: new Date('2026-08-31T00:00:00-06:00'),
  target: ({ user }) => {
    if (!store.getters['featureFlags/officeAutomationPromotion']) {
      return false
    }

    // Exclude host-organization users (EPs).
    if (user.isHostOrganizationUser) {
      return false
    }

    // Then require an organization-scoped Admin assignment.
    const organizationIds = user.lineage.filter((l) => l.type === 'Organization').map((o) => o.id)

    return user.roleAssignments.some(
      (ra) => ra.role === 'Admin' && organizationIds.includes(ra.businessUnitId),
    )
  },
  component: () => Component,
}

export default banner
